import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as MerchantModule from '@Modules/terminalManagementSystem/merchant/pages';
import React from 'react';

const URL = URLConfig.TERMINAL_MANAGEMENT_SYSTEM.MERCHANT;

const MerchantRoutes = [
    <Route
      path={URL.MERCHANT_REQUEST}
      element={<MerchantModule.MerchantRequest />}
    />,
    <Route
      path={URL.MERCHANT_REQUEST_VALIDATION}
      element={<MerchantModule.MerchantRequestValidation />}
    />,
    <Route
      path={URL.MERCHANT_CONSULTATION}
      element={<MerchantModule.MerchantConsultation />}
    />,
    <Route
      path={URL.MERCHANT_CONSULTATION_DETAILS + ':id/'}
      element={<MerchantModule.MerchantConsultationDetails />}
    />
];

export default MerchantRoutes;
